const { fetcher } = require('services/helpers/responseHandler')

const find = async ({ firstName, lastName, email, phone, subscriberId }) =>
  await fetcher.get('subscribers/find', {
    firstName,
    lastName,
    phone,
    email,
    subscriberId
  })

const getBookings = async ({ subscriberId }) =>
  await fetcher.get('invitesubscribers/load/subscriber/bookings', { subscriberId })

const update = async ({
  byChatId,
  bySubscriptionId,
  firstName,
  lastName,
  lastCheckout,
  email,
  loyaltyId,
  inviteSubscriptionStatus
}) =>
  await fetcher.patch('subscribers', {
    byChatId,
    bySubscriptionId,
    firstName,
    lastName,
    inviteSubscriptionStatus,
    lastCheckout,
    email,
    loyaltyId
  })

const getLastShortLink = async ({ subscriberId }) =>
  await fetcher.get(`subscribers/last/short/link`, { subscriptionId: subscriberId })

const getLastSubscribers = async () => await fetcher.get('subscribers/recent')

const applyBonus = async ({ subscriberId }) =>
  await fetcher.patch(`subscribers/bonus/${subscriberId}`)

const getSubscribersCountFromEvents = async (
  { includeEvents, notIncludeEvents },
  abortController
) =>
  await fetcher.post(
    'subscribers/events/count',
    { includeEvents, notIncludeEvents },
    abortController
  )

const sendTextToSubscribersFromEvents = async ({
  includeEvents,
  notIncludeEvents,
  messageTemplate
}) =>
  await fetcher.post('events/announcement', {
    includeEvents,
    notIncludeEvents,
    details: {
      messageTemplate,
      messageMediaUrls: []
    }
  })

const sendCustomText = async ({ subscriptionIds, content, includeLink = true }) =>
  await fetcher.post('subscribers/invite/custom', {
    subscriptionIds,
    content,
    includeLink
  })

const sentConsentRequestText = async ({ chatId }) =>
  await fetcher.patch('subscribers/statusChange', {
    byChatId: chatId,
    inviteSubscriptionStatus: 'ConsentGiven',
    isAvailableForMessage: true
  })

const updateStatus = {
  consentGiven: async ({ chatId }) =>
    await fetcher.patch('subscribers/statusChange', {
      byChatId: chatId,
      inviteSubscriptionStatus: 'ConsentGiven',
      isAvailableForMessage: false
    }),
  doNotCall: async ({ chatId, sendUpdateText, customMessage }) =>
    await fetcher.patch('subscribers/statusChange', {
      byChatId: chatId,
      inviteSubscriptionStatus: 'DoNotCall',
      isAvailableForMessage: sendUpdateText,
      customMessage
    })
}

const subscribersApi = {
  find,
  update,
  getBookings,
  getLastShortLink,
  getLastSubscribers,
  applyBonus,
  getSubscribersCountFromEvents,
  sendTextToSubscribersFromEvents,
  sendCustomText,
  sentConsentRequestText,
  updateStatus
}

export default subscribersApi
